import { RoadmapPortfolioDetails } from '@cfp/shared/roadmap';

export const NO_ROADMAP_DATA: RoadmapPortfolioDetails = {
  co2ConsumptionBaseYear: 124.510464535,
  targetCo2Consumption2030: 63.260464535,
  gbTargetCo2Consumption2035: 27.010464535,
  targetCo2Consumption2050: 5.760464535,
  currencyCode: null,
  years: [
    {
      year: null,
      investment: 19300,
      costReduction: 4180,
      co2ConsumptionReduction: 10.72406005859375,
      co2Consumption: 124.510464535
    },
    {
      year: 2020,
      investment: 0,
      costReduction: 0,
      co2ConsumptionReduction: 0,
      co2Consumption: 124.510464535
    },
    {
      year: 2021,
      investment: 0,
      costReduction: 0,
      co2ConsumptionReduction: 0,
      co2Consumption: 124.510464535
    },
    {
      year: 2022,
      investment: 12300,
      costReduction: 8900,
      co2ConsumptionReduction: 24.68656015396118,
      co2Consumption: 99.82390438103882
    },
    {
      year: 2023,
      investment: 250,
      costReduction: 11000,
      co2ConsumptionReduction: 30.379240036010742,
      co2Consumption: 94.13122449898925
    },
    {
      year: 2024,
      investment: 3600,
      costReduction: 12100,
      co2ConsumptionReduction: 33.41127014160156,
      co2Consumption: 91.09919439339843
    },
    {
      year: 2025,
      investment: 2200,
      costReduction: 13600,
      co2ConsumptionReduction: 37.47746992111206,
      co2Consumption: 87.03299461388794
    },
    {
      year: 2026,
      investment: 2500,
      costReduction: 15580,
      co2ConsumptionReduction: 42.88422966003418,
      co2Consumption: 81.62623487496582
    },
    {
      year: 2027,
      investment: 11000,
      costReduction: 17080,
      co2ConsumptionReduction: 44.4368896484375,
      co2Consumption: 80.0735748865625
    },
    {
      year: 2028,
      investment: 4700,
      costReduction: 17670,
      co2ConsumptionReduction: 45.05795466899872,
      co2Consumption: 79.45250986600128
    },
    {
      year: 2029,
      investment: 0,
      costReduction: 17670,
      co2ConsumptionReduction: 45.05795466899872,
      co2Consumption: 79.45250986600128
    },
    {
      year: 2030,
      investment: 0,
      costReduction: 17670,
      co2ConsumptionReduction: 45.05795466899872,
      co2Consumption: 79.45250986600128
    }
  ]
};
